<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
            <p class="c2b-router-name">Clientes não pagantes</p>
        </div>

        <div class="c2b-content">
            <div class="modal" tabindex="-1" role="dialog" id="c2b-subscriber-forgotten-list-filter-modal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Número de dias desde o cadastro</label>
                                    <input type="number"
                                        class="form-control"
                                        v-model="subscriberForgottenFilterForm.days">
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Situação dos pedidos</label>

                                    <multiselect
                                        v-model="subscriberForgottenFilterForm.orderOption"
                                        :options="orderOptionList"
                                        :multiple="false"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="">
                                    </multiselect>
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Situação dos produtos</label>

                                    <multiselect
                                        v-model="subscriberForgottenFilterForm.productOption"
                                        :options="productOptionList"
                                        :multiple="false"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="">
                                    </multiselect>
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Situação das categorias</label>

                                    <multiselect
                                        v-model="subscriberForgottenFilterForm.categoryOption"
                                        :options="categoryOptionList"
                                        :multiple="false"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="">
                                    </multiselect>
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Situação das marcas</label>

                                    <multiselect
                                        v-model="subscriberForgottenFilterForm.brandOption"
                                        :options="brandOptionList"
                                        :multiple="false"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="">
                                    </multiselect>
                                </div>                                

                                <div class="col-12 form-group">
                                    <label>Nome do cliente</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberForgottenFilterForm.name" />
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Retraguarda</label>
                                    <multiselect
                                        v-model="subscriberForgottenFilterForm.backend"
                                        :options="backendOptionList"
                                        :multiple="false"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        label="description"
                                        track-by="enum"
                                        placeholder="">
                                    </multiselect>
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Alias</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberForgottenFilterForm.alias" />
                                </div>

                                <div class="col-12 col-md-4 form-group">
                                    <label>Id externo</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberForgottenFilterForm.idExternal" />
                                </div>

                                <div class="col-12 col-md-6">
                                    <SwitchToggle 
                                        :prop-check="subscriberForgottenFilterForm.invalidateCache"
                                        :label-checked="'Limpar cache'"
                                        :label-unchecked="'Limpar cache'"
                                        @updated="invalidateCacheHandler" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getSubscriberListWithFilter(subscriberForgottenFilterForm)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <SubscriberSpecificCmp ref="subscriberSpecific" />

            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading v-if="loading || loadingFilter" />

            <div v-show="!loading && !loadingFilter">
                <div class="mb-3">
                    <button class="btn btn-primary" @click="openFilterModal()">
                        Filtro
                    </button>

                    <json-to-csv
                        class="btn btn-outline-secondary ml-3"
                        :data="subscriberForgottenListCsv"
                        name="nao_pagantes.csv">
                        Exportar para CSV
                    </json-to-csv>
                </div>

                <FilterInformationCmp 
                    v-if="!loading"
                    :filter-submitted="subscriberForgottenFilterFormSubmitted"
                    :filter-properties="subscriberForgottenFilterProperties" />

                <NothingFound v-if="nothingToShow" />

                <div class="table-responsive" v-show="!nothingToShow">
                    <table class="table table-hover table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th class>Retaguarda</th>
                                <th class="text-right">Tempo</th>
                                <th class="text-right">Pedidos</th>
                                <th class="text-right">Produtos</th>
                                <th class="text-right">Categorias</th>
                                <th class="text-right">Marcas</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(sub, index) of subscriberForgottenListFiltered" :key="index">
                                <td class="col-6">
                                    <p class="mb-0">{{sub.subscriber.realName}}</p>
                                    <small class="text-muted">{{sub.subscriber.name}}</small>
                                    <br>
                                    <small class="text-muted">{{sub.subscriber.alias}}</small>
                                    <br>
                                    <small class="text-muted">{{sub.subscriber.idExternal}}</small>
                                </td>
                                <td class>{{sub.info.backend.name}}</td>
                                <td class="text-right">{{sub.subscriber.days}} dias</td>
                                <td class="text-right">{{sub.info.orders}}</td>
                                <td class="text-right">{{sub.info.products}}</td>
                                <td class="text-right">{{sub.info.categories}}</td>
                                <td class="text-right">{{sub.info.brands}}</td>
                                <td class="text-center c2b-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!sub.loadingListAction"/>
                                        <fa icon="sync-alt" spin v-show="sub.loadingListAction"/>
                                    </button>

                                    <div class="dropdown-menu">  
                                        <span class="dropdown-item" 
                                            @click="openSpecificSubscriberModel(sub)">Detalhes</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="subscriberForgottenListFiltered.length" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModalService from '../../utils/services/ModalService'
import subscriberService from '../services/SubscriberService'
import { SubscriberForgottenListFilterFormModel, SubscriberEntityPresence } from '../models/SubscriberForgottenListFilterFormModel'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import { dateFilter } from '@/utils/filters/DateTimeFilter'
import { cloneDeep } from 'lodash'
import SubscriberSpecificCmp from '../components/SubscriberSpecificCmp'
import { BackendEnum } from '../../backend/enums/BackendEnum'

const ID_SUBSCRIBER_FORGOTTEN_LIST_FILTER_MODAL = '#c2b-subscriber-forgotten-list-filter-modal'

export default {
    name: 'SubscriberForgottenListView',
    components: {
        FilterInformationCmp,
        SubscriberSpecificCmp,
    },
    data() {
        return {
            loading: true,
            loadingFilter: false,
            subscriberForgottenList: [],
            subscriberForgottenListCsv: [],
            subscriberForgottenFilterForm: new SubscriberForgottenListFilterFormModel(),
            subscriberForgottenFilterFormSubmitted: new SubscriberForgottenListFilterFormModel(),
            backendOptionList: SubscriberForgottenListFilterFormModel.getBackendOptions(),
            productOptionList: SubscriberForgottenListFilterFormModel.getEntityOptions('produto'),
            categoryOptionList: SubscriberForgottenListFilterFormModel.getEntityOptions('categoria'),
            brandOptionList: SubscriberForgottenListFilterFormModel.getEntityOptions('marca'),
            orderOptionList: SubscriberForgottenListFilterFormModel.getEntityOptions('pedido'),
            breadcrumbList: [
                {
                    id: 1,
                    path: '/clientes',                    
                    description: 'Clientes',
                },
                {
                    id: 1,
                    description: 'Relatório de clientes não pagantes',
                },
            ],
            subscriberForgottenFilterProperties: [
                {
                    type: 'datetime',
                    label: 'Última atualização',
                    property: 'lastUpdate',
                },
                {
                    type: 'number',
                    label: 'Número de dias desde o cadastro',
                    property: 'days',
                },
                {
                    type: 'object',
                    label: 'Retaguarda',
                    property: 'backend',
                    propertyInObject: 'description',
                },
                {
                    type: 'string',
                    label: 'Nome do cliente',
                    property: 'name',
                },
                {
                    type: 'string',
                    label: 'Alias',
                    property: 'alias',
                },
                {
                    type: 'string',
                    label: 'Id externo',
                    property: 'idExternal',
                },
                // {
                //     type: 'object',
                //     label: 'Situação dos pedidos',
                //     property: 'orderOption',
                //     propertyInObject: 'description',
                // },
                // {
                //     type: 'object',
                //     label: 'Situação dos produtos',
                //     property: 'productOption',
                //     propertyInObject: 'description',
                // },
                // {
                //     type: 'object',
                //     label: 'Situações das categorias',
                //     property: 'categoryOption',
                //     propertyInObject: 'description',
                // },
                // {
                //     type: 'object',
                //     label: 'Situação das marcas',
                //     property: 'brandOption',
                //     propertyInObject: 'description',
                // },                
            ],
        }
    },
    async mounted() {
        try {
            const response = await subscriberService.getNonPayingSubscriberList()
            this.subscriberForgottenFilterForm.lastUpdate = response.lastUpdate
            this.subscriberForgottenList = response.list
            this.subscriberForgottenFilterFormSubmitted = cloneDeep(this.subscriberForgottenFilterForm)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getSubscriberListWithFilter(subscriberForgottenFilter) {
            this.loadingFilter = true
            
            try {
                if (this.subscriberForgottenFilterForm.invalidateCache) {
                    await subscriberService.invalidateNonPayingSubscriberListCache()
                }

                const response = await subscriberService.getNonPayingSubscriberList()
                this.subscriberForgottenFilterForm.lastUpdate = response.lastUpdate
                this.subscriberForgottenList = response.list
                this.subscriberForgottenFilterFormSubmitted = cloneDeep(subscriberForgottenFilter)
                this.closeFilterModal()

                // Forces the cache to be invalidated next time the filter is made
                this.subscriberForgottenFilterForm.invalidateCache = false
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingFilter = false
        },
        async openSpecificSubscriberModel(sub) {
            sub.loadingListAction = true

            await this.$refs.subscriberSpecific.openModal(sub.subscriber.id)

            sub.loadingListAction = false
        },
        async openFilterModal() {
            ModalService.show(ID_SUBSCRIBER_FORGOTTEN_LIST_FILTER_MODAL)
        },
        closeFilterModal() {
            ModalService.hide(ID_SUBSCRIBER_FORGOTTEN_LIST_FILTER_MODAL)
        },
        clearFilter() {
            this.subscriberForgottenFilterForm = new SubscriberForgottenListFilterFormModel()
        },
        invalidateCacheHandler(info) {
            this.subscriberForgottenFilterForm.invalidateCache = info
        },
    },
    computed: {
        nothingToShow() {
            return !this.loading && !this.loadingFilter && !this.subscriberForgottenListFiltered.length
        },
        subscriberForgottenListFiltered() {
            let subscriberForgottenList = this.subscriberForgottenList.filter((sub) => {
                return sub.subscriber.days < this.subscriberForgottenFilterFormSubmitted.days
            })

            if (this.subscriberForgottenFilterFormSubmitted.backend.enum !== BackendEnum.All) {
                subscriberForgottenList = subscriberForgottenList.filter((sub) => {
                    return sub.info.backend.id === this.subscriberForgottenFilterFormSubmitted.backend.enum
                })
            }

            if (!!this.subscriberForgottenFilterFormSubmitted.name) {
                subscriberForgottenList = subscriberForgottenList.filter((sub) => {
                    return sub.subscriber.realName.toLowerCase().indexOf(this.subscriberForgottenFilterFormSubmitted.name.toLowerCase()) > -1 ||
                           sub.subscriber.name.toLowerCase().indexOf(this.subscriberForgottenFilterFormSubmitted.name.toLowerCase()) > -1
                })
            }

            if (!!this.subscriberForgottenFilterFormSubmitted.alias) {
                subscriberForgottenList = subscriberForgottenList.filter((sub) => {
                    return sub.subscriber.alias.toLowerCase().indexOf(this.subscriberForgottenFilterFormSubmitted.alias.toLowerCase()) > -1
                })
            }

            if (!!this.subscriberForgottenFilterFormSubmitted.idExternal) {
                subscriberForgottenList = subscriberForgottenList.filter((sub) => {
                    return sub.subscriber.idExternal.toLowerCase().indexOf(this.subscriberForgottenFilterFormSubmitted.idExternal.toLowerCase()) > -1
                })
            }

            switch (this.subscriberForgottenFilterFormSubmitted.productOption.enum) {
                case SubscriberEntityPresence.NotPresent:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.products === 0)
                    break;

                case SubscriberEntityPresence.Present:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.products > 0)
                    break;
            }

            switch (this.subscriberForgottenFilterFormSubmitted.categoryOption.enum) {
                case SubscriberEntityPresence.NotPresent:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.categories === 0)
                    break;

                case SubscriberEntityPresence.Present:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.categories > 0)
                    break;
            }

            switch (this.subscriberForgottenFilterFormSubmitted.brandOption.enum) {
                case SubscriberEntityPresence.NotPresent:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.brands === 0)
                    break;

                case SubscriberEntityPresence.Present:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.brands > 0)
                    break;
            }

            switch (this.subscriberForgottenFilterFormSubmitted.orderOption.enum) {
                case SubscriberEntityPresence.NotPresent:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.orders === 0)
                    break;

                case SubscriberEntityPresence.Present:
                    subscriberForgottenList = subscriberForgottenList.filter((sub) => sub.info.orders > 0)
                    break;
            }

            return subscriberForgottenList
        },
    },
    watch: {
        subscriberForgottenListFiltered(val) {
            this.subscriberForgottenListCsv = val.map((s) => {
                return {
                    razao_social: s.subscriber.realName,
                    nome_fantasia: s.subscriber.name,
                    alias_muven: s.subscriber.alias,
                    codigo_crm: s.subscriber.idExternal,
                    criado_em: dateFilter(s.subscriber.createdAt),
                    numero_dias_desde_cadastro: s.subscriber.days,
                    quantidade_pedidos_muven: s.info.orders,
                    quantidade_produtos_muven: s.info.products,
                    quantidade_categorias_muven: s.info.categories,
                    quantidade_marcas_muven: s.info.brands,
                    retaguarda: s.info.backend.name,
                }
            })
        },
    },
}
</script>

